import { useCallback } from 'react';

import { useBatchComponentUpdateContext } from '../../shared/batch-component-update.context';
import { FillInBlanksProperties } from '../fill-in-blanks.constants';
import type { SuggestedAnswerFragment } from '../../suggested-answers/suggested-answers.graphql.generated';
import { getDeleteSentencePayload } from './fill-in-blanks-settings-sentence.utils';

type Props = {
  id: string;
  sectionId: string;
  properties: FillInBlanksProperties;
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
};

const useFillInBlanksDeleteSentence = ({
  id,
  sectionId,
  properties,
  suggestedAnswerProperties,
}: Props) => {
  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const handleDeleteSentence = useCallback(
    (itemId: string) => {
      const { sentences, suggestedAnswers } = getDeleteSentencePayload({
        activeSentenceId: itemId,
        sentences: properties.fillInBlanks.sentences,
        suggestedAnswerProperties,
      });
      updateComponentProperties({
        input: {
          componentId: id,
          sectionId,
          componentData: {
            properties: {
              fillInBlanks: {
                ...properties.fillInBlanks,
                sentences,
              },
            },
          },
          suggestedAnswers,
        },
        properties: {
          ...properties,
          fillInBlanks: {
            ...properties.fillInBlanks,
            sentences,
          },
        },
        typename: 'ActivitiesFillInBlanksResponseComponent',
      });
    },
    [
      id,
      sectionId,
      properties,
      suggestedAnswerProperties,
      updateComponentProperties,
    ]
  );

  return {
    handleDeleteSentence,
  };
};

export default useFillInBlanksDeleteSentence;
